import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';

// Auth Services


@Injectable({ providedIn: 'root' })
export class SuperAdminAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.role === 'SuperAdmin') {
            return true;
        }

        // Check if user data is in storage
        const storedUser = localStorage.getItem('currentUser');
        if (storedUser && JSON.parse(storedUser).role === 'SuperAdmin') {
            return true;
        }

        // Redirect to login page if not teacherized
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
